<div class="changelog-page">

  <!-- Zafiksowana informacja o odświeżaniu -->
  <div class="changelog-refresh-note">
    <mat-icon>info</mat-icon>
    <span>
      {{ 'CHANGELOG.REFRESH_NOTE_BEFORE' | translate }}
      <strong>Ctrl + F5</strong> / <strong>Ctrl + Shift + R</strong>{{ 'CHANGELOG.REFRESH_NOTE_AFTER' | translate }}
    </span>
  </div>

  <h1 class="changelog-title">{{ 'CHANGELOG.TITLE' | translate }}</h1>
  <p class="changelog-lead">{{ 'CHANGELOG.LEAD' | translate }}</p>

  <div class="changelog-list">
    <div class="changelog-item" *ngFor="let e of entries">
      <div class="changelog-item-head">
        <span class="changelog-tag" [ngClass]="tagClass(e.tag)" *ngIf="e.tag">{{ tagLabelKey(e.tag) | translate }}</span>
        <span class="changelog-date">{{ e.date }}</span>
      </div>
      <h3 class="changelog-item-title">{{ entryTitle(e) }}</h3>
      <p class="changelog-item-text">{{ entryText(e) }}</p>
    </div>

    <div class="changelog-empty" *ngIf="entries.length === 0">
      {{ 'CHANGELOG.EMPTY' | translate }}
    </div>
  </div>

</div>
